// Абстрактный ввод. Любой источник (keyboard, touch, gamepad) пишет в эти поля,
// игрок читает только отсюда — не знает о конкретных источниках.
export class InputState {
  // Continuous (зажатые)
  left = false;
  right = false;
  up = false;
  down = false;
  jumpHeld = false;
  focusHeld = false;

  // One-shot (нажато в этом кадре)
  jumpPressed = false;
  attackPressed = false;
  dashPressed = false;
  spellPressed = false;

  resetContinuous() {
    this.left = false;
    this.right = false;
    this.up = false;
    this.down = false;
    this.jumpHeld = false;
    this.focusHeld = false;
  }

  resetOneShot() {
    this.jumpPressed = false;
    this.attackPressed = false;
    this.dashPressed = false;
    this.spellPressed = false;
  }
}
